import React, { memo } from 'react';

const Sparkles = () => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2.00006C7 2.00006 7.2207 4.06004 8.08036 4.9197C8.94003 5.77936 11 6.00006 11 6.00006C11 6.00006 8.94003 6.22076 8.08036 7.08042C7.2207 7.94009 7 10.0001 7 10.0001C7 10.0001 6.7793 7.94009 5.91964 7.08042C5.05997 6.22076 3 6.00006 3 6.00006C3 6.00006 5.05997 5.77936 5.91964 4.9197C6.7793 4.06004 7 2.00006 7 2.00006Z"
      fill="white"
    />
    <path
      d="M2.5 6.10352e-05C2.5 6.10352e-05 2.63794 1.28755 3.17523 1.82483C3.71252 2.36212 5 2.50006 5 2.50006C5 2.50006 3.71252 2.638 3.17523 3.17529C2.63794 3.71258 2.5 5.00006 2.5 5.00006C2.5 5.00006 2.36206 3.71258 1.82477 3.17529C1.28748 2.638 0 2.50006 0 2.50006C0 2.50006 1.28748 2.36212 1.82477 1.82483C2.36206 1.28755 2.5 6.10352e-05 2.5 6.10352e-05Z"
      fill="white"
    />
  </svg>
);

export default memo(Sparkles);
